import React, { useEffect, useMemo } from 'react';
import i18n from '../utils/i18n';

type Requirement = {
  requirement: string;
  regex: string;
  match?: boolean;
};

const data: Requirement[] = [
  {
    requirement: '1',
    regex: '(^.{12,}$)',
  },
  {
    requirement: '2',
    regex: '(?=.*[a-z])(?=.*[A-Z])',
  },
  {
    requirement: '3',
    regex: '[!?@#$%^&*)(+=._-]',
  },
];

type Props = {
  password: string;
  onMeetAllRequirements: () => void;
  onRequirementsNotMet?: () => void;
};

const PasswordRequirements: React.FC<Props> = ({
  password,
  onMeetAllRequirements,
  onRequirementsNotMet,
}) => {
  const requirements: Requirement[] = useMemo(() => {
    if (!password) {
      return data;
    }

    return data.map((identity) => {
      const match = new RegExp(identity.regex).test(password.trim());

      return { match, ...identity };
    });
  }, [password]);

  useEffect(() => {
    const existsRemainingRequirements = requirements.find(
      (requirement) => !requirement.match
    );

    if (!existsRemainingRequirements && password.length > 0) {
      onMeetAllRequirements();
    } else if (existsRemainingRequirements && onRequirementsNotMet) {
      onRequirementsNotMet();
    }
  }, [requirements, onMeetAllRequirements, onRequirementsNotMet, password.length]);

  if (!password) {
    return null;
  }

  return (
    <div className="password-requirements">
      {requirements.map((req) => {
        return (
          <div className="requirement-item" key={req.requirement}>
            <i
              className={`requirement-icon ${req.match ? 'feather-check-circle text-success' : 'feather-circle text-muted'}`}
            />
            <span className={`requirement-text ${req.match ? 'text-success' : 'text-muted'}`}>
              {i18n.t<string>(`PasswordRules.${req.requirement}`)}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default PasswordRequirements;
